<template>
  <div
    class="overlay-dialog__changes"
		v-if="changes.length"
  >
    <div
			class="overlay-dialog__text"
			v-if="text"
			v-html="text"
		/>
    <ul
      class="overlay-dialog__changes-list"
    >
      <li
        class="overlay-dialog__changes-list-item"
        v-for="change in changes"
        :key="change.id"
        :class="[
          `overlay-dialog__changes-list-item--${change.type}`
        ]"
      >
				<img
					v-if="change.image"
					class="overlay-dialog__changes-list-item-image"
					:src="change.image"
					alt="Product Image"
				>
				<span
					class="overlay-dialog__changes-list-item-name"
					v-html="change.name"
				/>
			</li>
    </ul>

  </div>
</template>

<script>
export default {
  props: {
    text: {
      default: ''
    },
    changes: {
      default: []
    }
  }
}
</script>

<style>

</style>
